"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HCaptchaHandler = void 0;
const query_1 = require("./query");
class HCaptchaHandler {
    constructor(form, callback) {
        this.form = form;
        this.siteKey = query_1.Z.oneFrom(form, '#h-captcha').dataset.siteKey;
        this.callback = callback;
        let instance = this;
        let hc = window['hcaptcha'].render('h-captcha', {
            sitekey: this.siteKey,
            //sitekey: '10000000-ffff-ffff-ffff-000000000001',
            //theme: 'dark',
            callback(resp) {
                query_1.Z.forEachFrom(form, '[name="hc-token"]', input => input.value = resp);
                query_1.Z.submitFormAsync(null, instance.form, ok => {
                    console.log('ok!', ok);
                    if (instance.callback)
                        callback.call(instance, ok);
                    //quoteId = container.dataset.id = JSON.parse(ok);
                    /*fetch(`/quote/size/${quoteId}`)
                        .then(resp => {
                            if (resp.ok) {
                                resp.text()
                                    .then(html => {
                                        let dom = O.parseHTML(html);

                                        while (container.childElementCount)
                                            container.firstElementChild.remove();

                                        container.appendChild(dom);

                                        document.dispatchEvent(new Event('received-gui'));

                                        selectSpecificationsButton.classList.remove('d-none');
                                        cabinetSelectTable = O.selectOneFrom(modal, '.cabinet-design-table');
                                    });
                            }
                        });*/
                }, error => {
                    console.log('Error', error);
                });
            },
        });
        console.log(hc);
        console.log(window['hcaptcha']);
    }
}
exports.HCaptchaHandler = HCaptchaHandler;
//# sourceMappingURL=captcha.js.map